
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12739',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12739",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.480",
  "data-fetching-client": "static-1.9775",
  "foundations-components": "static-1.8163",
  "foundations-components-legacy": "static-1.1188",
  "foundations-theming": "static-1.4545",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8134",
  "hub-http-shared-msw-handlers": "static-1.10250",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11589",
  "I18n": "static-7.1638",
  "jasmine-runner": "static-1.6572",
  "marketplace-storefront-base": "static-1.12802",
  "quartz": "static-1.7176",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16798",
  "reactive-variable-buffer-atom": "static-1.2971",
  "reporting-testing-lib": "static-1.9975",
  "settings-ui-lib": "static-1.12635",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7348",
  "ui-addon-i18n": "static-1.11263",
  "ui-addon-react-router-dom": "static-1.9651",
  "unified-auth": "static-1.629",
  "unified-auth-core-lib": "static-1.911",
  "usage-tracker": "static-1.7463",
  "usage-tracker-core": "static-1.7313",
  "customer-data-property-utils": "static-1.8209",
  "hub-http": "static-1.6336",
  "integrations-lib": "static-1.16525",
  "marketplace-ui-common": "static-1.20156",
  "property-management-iframe": "static-1.13554",
  "quartz-config": "static-1.954",
  "quartz-core": "static-1.6395",
  "quartz-routing": "static-1.606",
  "quick-fetch": "static-1.4001",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4771",
  "ts-schema": "static-1.4165",
  "ui-universal-auth": "static-1.9115",
  "UIComponents": "static-3.8535",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3481",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3453",
  "quartz-webpack": "static-1.3400",
  "bend-plugin-quartz-routing": "static-1.254",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4432",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4987",
  "foundations-theming-specialty": "static-1.2261",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9537",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.36",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5425",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2192",
  "ui-fonts": "static-1.851",
  "ui-images": "static-2.1181",
  "bend-plugin-foundations-theming": "static-1.3028",
  "foundations-theming-base": "static-1.3530",
  "stylex": "static-1.35",
  "HeadJS": "static-2.769",
  "hs-test-utils-bend-plugin": "static-1.3245",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4439",
  "ai-components-ui-library": "static-1.9249",
  "ai-rendering-library": "static-1.10590",
  "chirp-fetch": "static-1.2001",
  "connections-embed-lib": "static-1.1210",
  "copilot-toolkit": "static-1.11435",
  "feedback-loader": "static-1.29516",
  "laboratory-lib": "static-3.7267",
  "marketplace-embed": "static-1.22454",
  "marketplace-ui-details": "static-1.10051",
  "marketplace-ui-reviews": "static-1.20111",
  "marketplace-ui-tracking": "static-1.14326",
  "sanitize-text": "static-1.8259",
  "ui-addon-video-player": "static-1.8817",
  "usage-tracker-multi": "static-1.5877",
  "usage-tracker-session-replay": "static-1.5149",
  "wootric-nps": "static-1.7066",
  "quartz-head": "static-1.841",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4765",
  "immer": "static-1.33",
  "immerable": "static-1.4264",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2570",
  "reporting-data": "static-1.68042",
  "cssUtils": "static-1.824",
  "flux-actions": "static-1.346",
  "HubStyle": "static-2.11896",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10321",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10476",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7453",
  "icons": "static-2.654",
  "marketplace-ui-apps-core": "static-1.18688",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4625",
  "foundations-components-test-utils": "static-1.5646",
  "quartz-i18n": "static-1.851",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.16",
  "ads-unified-auth-lib": "static-1.378",
  "google-sheets-integration-lib": "static-1.579",
  "microsoft-drive-integration-lib": "static-1.712",
  "surveymonkey-integration-lib": "static-1.36",
  "slack-ui-library": "static-1.10510",
  "fsm": "static-1.3842",
  "customer-data-objects": "static-1.7792",
  "property-translator": "static-1.5510",
  "hs-locale-management": "static-1.165",
  "frontend-preferences-client": "static-1.8041",
  "hs-promise-utils": "static-1.5706",
  "hubspot-apollo-client": "static-1.4991",
  "integrations-error-boundary-lib": "static-1.13940",
  "integrations-tracking-lib": "static-1.5720",
  "native-integrations-shared-strings": "static-1.7896",
  "reselect": "static-2.16",
  "sanitize": "static-1.4590",
  "superstore": "static-1.4873",
  "ui-shepherd-react": "static-3.10361",
  "ai-settings-ui-library": "static-1.8072",
  "hub-http-janus": "static-1.845",
  "hubspotter-http": "static-1.4734",
  "immutable-less": "static-1.4767",
  "marketplace-ui-client-types": "static-1.17563",
  "nav-meta": "static-1.29933",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18150",
  "inbound-db-properties-service-client": "static-1.3929",
  "property-management-common": "static-1.5842",
  "ui-addon-iframeable": "static-1.9181",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.851",
  "quartz-test": "static-1.851",
  "quartz-tracking": "static-1.555",
  "trellis-components": "static-1.2211",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.181",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21846",
  "ContentUtils": "static-1.68698",
  "customer-data-objects-ui-components": "static-1.13143",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2611",
  "breeze-engine-core": "static-1.398",
  "breeze-onboarding-components": "static-1.251",
  "customer-data-filters-ui": "static-1.40200",
  "customer-data-reference-ui-components": "static-1.13288",
  "embedded-academy-lib": "static-1.14751",
  "ExportDialog": "static-6.10494",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41598",
  "reporting-snowflake": "static-1.56660",
  "reporting-ui-components": "static-2.65313",
  "reporting-visualizations": "static-1.60118",
  "trellis-theming": "static-1.1055",
  "ui-addon-teams": "static-1.21698",
  "integrations-reconnect-lib": "static-1.183",
  "magpie-lib": "static-1.5626",
  "navigation-components": "static-1.18296",
  "breeze-engine-lib": "static-1.1120",
  "magpie-types": "static-1.5086",
  "simple-logging-lib": "static-1.3162",
  "ai-studio-lib": "static-1.11953",
  "app-governance-lib": "static-1.1921",
  "developer-experience-shared-components": "static-1.10627",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8122",
  "ui-product-approvals": "static-1.28617",
  "ui-tool-access": "static-1.10263",
  "usage-based-billing-components-lib": "static-1.9423",
  "usage-tracker-anonymous": "static-1.5880",
  "usage-tracker-public": "static-1.7274",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3670",
  "persist-promise": "static-1.3814",
  "reference-resolvers": "static-1.8288",
  "ui-extensibility-client-types": "static-1.4037",
  "hubspot-apollo-cache": "static-1.450",
  "universal-page-editor-lib": "static-1.3131",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3102",
  "atom": "static-1.5189",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6090",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1657",
  "crm-component-utils": "static-1.39385",
  "crm-properties-common-lib": "static-1.6003",
  "customer-data-properties": "static-1.51970",
  "framework-data-schema-resolvers": "static-1.7006",
  "property-value-citations": "static-1.2584",
  "reference-resolvers-lite": "static-1.8211",
  "ui-business-units-lib": "static-1.9181",
  "navigation-messaging": "static-1.7623",
  "hubspotter-http-shared-msw-handlers": "static-1.10248",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4929",
  "content-icons-ui": "static-1.2258",
  "customer-data-ui-utilities": "static-1.9939",
  "conversations-skeleton-state": "static-1.7361",
  "crm-message-bus": "static-1.43285",
  "customer-data-filters-ui-msw-helpers": "static-1.22635",
  "events-data-lib": "static-1.346",
  "FormUrlGenerator": "static-2.4836",
  "framework-builder-read-service-client": "static-1.4087",
  "framework-data-schema-quick-fetch": "static-1.6911",
  "multi-account-reference-resolvers": "static-1.1096",
  "onboarding-tours": "static-1.16820",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14013",
  "academy-common-lib": "static-1.14211",
  "content-assistance-lib": "static-1.7939",
  "dashboard-lib": "static-1.81983",
  "file-manager-components": "static-1.23948",
  "getting-started-shared-tasks": "static-1.18734",
  "hubspot-prosemirror": "static-1.18571",
  "hubspot-prosemirror-plugins": "static-1.18563",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20033",
  "share-with-third-party-component-lib": "static-1.8818",
  "ui-addon-draggable": "static-3.4873",
  "ui-asset-management-lib": "static-1.11179",
  "user-context": "static-1.5223",
  "growth-payments-core": "static-1.25719",
  "reporting-plugins": "static-1.10504",
  "reporting-reports": "static-1.67720",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.839",
  "nest": "static-1.345",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10741",
  "framework-listing-lib": "static-2.29019",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30976",
  "apps-service-types": "static-1.3913",
  "oauth-service-types": "static-1.4367",
  "react-dnd-compat": "static-1.4728",
  "ui-product-approvals-common": "static-1.512",
  "onboarding-scopes": "static-1.6574",
  "onboarding-tours-client": "static-1.5034",
  "platform-infra-nav-components": "static-1.7756",
  "subscription-experience-data-types": "static-1.15064",
  "crm-record-cards-service-types": "static-1.3671",
  "location-customization-utils-lib": "static-1.9601",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6093",
  "signup-constants": "static-1.19126",
  "signup-ui-url-generator": "static-2.8171",
  "card-properties-lib": "static-1.44540",
  "commerce-subscription-lib": "static-1.37411",
  "crm-actions": "static-1.6454",
  "crm-cards-sdk": "static-1.43934",
  "customer-data-properties-shared-msw-handlers": "static-1.9577",
  "customer-data-tracking": "static-1.7001",
  "hs-resources": "static-1.288",
  "pulse": "static-1.717",
  "calling-global-api": "static-1.64913",
  "calling-internal-common": "static-1.31424",
  "calling-lifecycle-internal": "static-1.66295",
  "calling-lifecycle-messages": "static-1.58589",
  "commerce-products-lib": "static-1.9988",
  "conditional-properties-service-client": "static-1.3880",
  "crm-links": "static-1.6422",
  "crm-pipelines-api-client-types": "static-1.4220",
  "external-options-client-types": "static-1.4210",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4300",
  "meetings-icalendar-utils-lib": "static-1.747",
  "multi-currency-client-types": "static-1.3773",
  "object-builder-ui-client": "static-1.49145",
  "pipeline-validation-client-types": "static-1.4049",
  "smart-property-lib": "static-1.7813",
  "tiered-pricing": "static-1.1518",
  "ui-addon-form-validation": "static-1.11104",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.125",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1172",
  "growth-data-modal": "static-1.5615",
  "growth-onboarding-confetti": "static-1.3179",
  "growth-onboarding-next-action-utils": "static-1.2250",
  "onboarding-tours-utils": "static-1.886",
  "ui-shepherd-tracker": "static-1.7742",
  "academy-service-client": "static-1.3797",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39447",
  "FileManagerLib": "static-1.39588",
  "SafeStorage": "static-1.4513",
  "video-embed": "static-1.36144",
  "ui-coaching-tips": "static-1.28882",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11652",
  "video-data-lib": "static-1.35310",
  "content-media-capture": "static-1.4863",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23829",
  "ui-addon-emoji-picker": "static-1.10000",
  "EmailSignatureEditor": "static-1.24630",
  "viral-links-lib": "static-1.7181",
  "data-token-picker": "static-1.16613",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.338",
  "timezone-utils": "static-2.5357",
  "seat-types-lib": "static-1.270",
  "getting-started-shared-tasks-store": "static-1.17852",
  "ui-addon-opt": "static-4.8475",
  "campaign-roi-lib": "static-1.9442",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25680",
  "framework-data-table": "static-2.12182",
  "marketing-platform-lib": "static-1.6979",
  "nudge-client-utils": "static-1.2824",
  "nudge-custom-ui-functions": "static-1.1231",
  "switchboard-lib": "static-1.337",
  "app-users-service-client": "static-1.5722",
  "app-users-service-types": "static-1.5130",
  "mini-checkout-client": "static-1.27094",
  "onboarding-utils": "static-1.5472",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28867",
  "edison-service-client-types": "static-1.503",
  "crm_data": "static-4.92332",
  "customer-data-sidebar": "static-2.46334",
  "enrichment-properties-lib": "static-1.16931",
  "ui-addon-draggable-compat": "static-2.4374",
  "universal-record-utils-lib": "static-1.1252",
  "commerce-billing-lib": "static-1.19469",
  "commerce-shared-components-lib": "static-1.18820",
  "commerce-tools-ui-lib": "static-1.10685",
  "crm-fe-perf": "static-1.23016",
  "event-emitter": "static-1.1063",
  "bend-plugin-pulse": "static-1.220",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31431",
  "shared-worker-versioning": "static-1.11149",
  "calling-usage-tracker": "static-1.6657",
  "voice-sms-access-library": "static-1.1440",
  "commerce-permissions": "static-1.890",
  "products-iframe-lib": "static-1.8251",
  "products-ui-components-shared-msw-handlers": "static-1.10632",
  "data-agent-kit": "static-1.388",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10333",
  "policy-lib": "static-1.6896",
  "react-tinymce": "static-1.55551",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10396",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54677",
  "tinymce-plugins": "static-1.57791",
  "tinymce-themes": "static-1.56647",
  "onboarding-data-sync-lib": "static-1.2162",
  "growth-onboarding-next-action-components": "static-1.2278",
  "user-context-client": "static-1.4694",
  "audio-components": "static-1.6095",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37099",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4649",
  "video-components": "static-1.13654",
  "outpost": "static-1.4283",
  "growth-onboarding-feedback-components": "static-1.6692",
  "content-media-composition-data-lib": "static-1.12667",
  "content-media-compositions": "static-2.16674",
  "media-bridge-lib": "static-1.19128",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4539",
  "commerce-tours-lib": "static-1.6313",
  "growth-onboarding-reliability": "static-1.5195",
  "sales-checkout-service-client": "static-1.3707",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21881",
  "sales-email-signature-service-client": "static-1.3964",
  "ts-utils-lib": "static-1.287",
  "crm-export-dialog": "static-1.6399",
  "crm-index-associations-lib": "static-1.6555",
  "crm-view-components": "static-1.625",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7445",
  "nudge-custom-function-registry": "static-1.2581",
  "nudge-renderer-utils": "static-1.2900",
  "whisper-core-api": "static-1.6872",
  "InboxConnectUtils": "static-4.15115",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5805",
  "settings-content-modals": "static-1.46409",
  "crm_universal": "static-1.22215",
  "customer-data-email": "static-1.18242",
  "card-payment-highlight-lib": "static-1.37506",
  "card-subscription-highlight-lib": "static-1.39834",
  "commerce-contract-lib": "static-1.12622",
  "invoices-highlight-card-lib": "static-1.55105",
  "orders-highlight-card-lib": "static-1.21783",
  "products-highlight-card-lib": "static-1.18271",
  "quotes-highlight-card-lib": "static-1.72404",
  "crm-source-interpretation-lib": "static-1.5457",
  "crm-object-search-query-utilities": "static-1.9845",
  "utility-belt": "static-1.2645",
  "payments-enrollment-embed-lib": "static-1.23254",
  "stripe-embedded-components": "static-1.7715",
  "customer-data-rte": "static-1.33301",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5955",
  "payments-post-enroll-local-storage-lib": "static-1.5220",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38494",
  "trials-service-types": "static-1.3996",
  "calling-orchestration-schema": "static-1.36217",
  "sales-views-client-types": "static-1.4370",
  "hub-http-contrib": "static-1.3157",
  "interframe": "static-3.4874",
  "tinymce-data": "static-1.40762",
  "ui-addon-sales-email": "static-1.5324",
  "layout-dnd-components": "static-1.12672",
  "layout-dnd-utils": "static-1.11647",
  "ui-brand-identity-lib": "static-1.15699",
  "NamespacedHubStyle": "static-2.9137",
  "meetings-connect-utils-lib": "static-1.7719",
  "social-insights-client-types": "static-1.22339",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4286",
  "checkout-sdk": "static-3.23937",
  "company-details-components": "static-1.6311",
  "payment-method-components": "static-1.6985",
  "pricing-pages-ui-components": "static-1.14705",
  "quote-checkout-service-types": "static-1.3579",
  "upgrade-catalog-service-types": "static-1.3635",
  "access-control-lib": "static-1.10550",
  "EmailComponents": "static-1.55091",
  "EmailData": "static-1.53768",
  "redux-less": "static-2.9596",
  "sequences-lib": "static-1.8244",
  "ui-gdpr-components": "static-1.10463",
  "products-ui-components": "static-1.40506",
  "accounting-integrations-ui-components": "static-1.7255",
  "invoices-ui-lib": "static-1.55121",
  "commerce-products-api": "static-1.2464",
  "invoices-iframe-lib": "static-1.57179",
  "quotes-modal-lib": "static-1.103082",
  "quotes-ui-lib": "static-1.81125",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28567",
  "ContentData": "static-1.68773",
  "layout-data-lib": "static-1.9972",
  "checkout-service-types": "static-1.3880",
  "hub-http-rxjs": "static-1.810",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4051",
  "billing-payments-client-types": "static-1.4104",
  "react-performance-metrics-lib": "static-1.670",
  "account-and-billing-fintech-outages": "static-3.18718",
  "pricing-pages-api": "static-1.14570",
  "ContentComponents": "static-2.71654",
  "marketing-contacts-lib": "static-1.10429",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46602",
  "messaging-usage-based-billing-components-lib": "static-1.1464",
  "automation-ui-source-apps": "static-1.19220",
  "automation-ui-types": "static-1.20138",
  "messaging-types-lib": "static-1.46339",
  "onboarding-settings-client": "static-1.4618",
  "sequences-client-types-lib": "static-1.8101",
  "commerce-tax-lib": "static-1.649",
  "price-books-api": "static-1.1242",
  "price-books-components": "static-1.1300",
  "property-description-translator": "static-1.3954",
  "ramp-editor": "static-1.452",
  "commerce-analytics-service-client": "static-1.3695",
  "totals-ui-components": "static-1.23912",
  "SalesContentIndexUI": "static-3.9405",
  "advanced-menus-core": "static-1.15321",
  "advanced-menus-lib": "static-1.12234",
  "ui-memberships-settings-lib": "static-1.34353",
  "segments-query-core": "static-1.1534",
  "automation-ui-ubb": "static-1.6054",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7452",
  "data-token-views": "static-1.16594",
  "forms-utils-lib": "static-1.12801",
  "payments-embed-points-lib": "static-1.13270",
  "simple-menus-core": "static-1.15320",
  "simple-menus-lib": "static-1.16837",
  "videoconference-integration-components": "static-1.6994",
  "mc-hard-limits-client-types": "static-1.12",
  "marketing-contacts-client": "static-1.7625",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77432",
  "short-messages-app-service-client": "static-1.4037",
  "web-interactives-components": "static-1.13965",
  "web-interactives-data": "static-1.13966",
  "messaging-shared-utils-lib": "static-1.913",
  "messaging-user-info-utils-lib": "static-1.1083",
  "email-portal-health-service-types": "static-1.1090",
  "line-items-api": "static-1.860",
  "commerce-totals-service-types": "static-1.3901",
  "FireAlarmUi": "static-1.4590",
  "sales-templates-service-types-lib": "static-1.4252",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22074",
  "automation-ui-usage-tracking": "static-1.21537",
  "data-studio-ubb": "static-1.3057",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27283",
  "collaboration-sidebar": "static-1.58186",
  "content-management-data-lib": "static-1.5608",
  "copilot-plugins": "static-1.11408",
  "cta-picker": "static-1.36704",
  "customer-agent-discovery-components-lib": "static-1.3414",
  "editor-components": "static-1.13399",
  "editor-iframe-lib": "static-1.8565",
  "error-messaging-js": "static-1.5307",
  "FormsCommonComponents": "static-1.86128",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10760",
  "SharedLegalStrings": "static-1.1858",
  "smart-content-core": "static-1.42756",
  "smart-content-lib": "static-1.43409",
  "social-composer-lib": "static-1.59575",
  "structured-content-lib": "static-1.25499",
  "theme-previewer-lib": "static-1.53559",
  "tinymce-copilot": "static-1.16745",
  "xray-recommendation-lib": "static-1.8055",
  "automation-ui-routing": "static-1.21495",
  "sql-reporting-client-types": "static-1.5728",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42449",
  "campaigns-utils-lib": "static-1.3307",
  "reporting-enablement": "static-1.23321",
  "chatspot-widget-iframe": "static-1.21837",
  "collaboration-sidebar-common": "static-1.2983",
  "forms-ai-lib": "static-1.4500",
  "codemirror-dlb": "static-1.58991",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6549",
  "report-customization-components": "static-1.13488",
  "data-quality-ui-library": "static-1.13335",
  "reporting-filters": "static-1.610",
  "reporting-insights-lib": "static-1.2085"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12739",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.480",
  "data-fetching-client": "/data-fetching-client/static-1.9775",
  "foundations-components": "/foundations-components/static-1.8163",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1188",
  "foundations-theming": "/foundations-theming/static-1.4545",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8134",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10250",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11589",
  "I18n": "/I18n/static-7.1638",
  "jasmine-runner": "/jasmine-runner/static-1.6572",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12802",
  "quartz": "/quartz/static-1.7176",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16798",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2971",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9975",
  "settings-ui-lib": "/settings-ui-lib/static-1.12635",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7348",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11263",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9651",
  "unified-auth": "/unified-auth/static-1.629",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.911",
  "usage-tracker": "/usage-tracker/static-1.7463",
  "usage-tracker-core": "/usage-tracker-core/static-1.7313",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8209",
  "hub-http": "/hub-http/static-1.6336",
  "integrations-lib": "/integrations-lib/static-1.16525",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20156",
  "property-management-iframe": "/property-management-iframe/static-1.13554",
  "quartz-config": "/quartz-config/static-1.954",
  "quartz-core": "/quartz-core/static-1.6395",
  "quartz-routing": "/quartz-routing/static-1.606",
  "quick-fetch": "/quick-fetch/static-1.4001",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4771",
  "ts-schema": "/ts-schema/static-1.4165",
  "ui-universal-auth": "/ui-universal-auth/static-1.9115",
  "UIComponents": "/UIComponents/static-3.8535",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3481",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3453",
  "quartz-webpack": "/quartz-webpack/static-1.3400",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.254",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4432",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4987",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2261",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9537",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.36",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5425",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2192",
  "ui-fonts": "/ui-fonts/static-1.851",
  "ui-images": "/ui-images/static-2.1181",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3028",
  "foundations-theming-base": "/foundations-theming-base/static-1.3530",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.769",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3245",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4439",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9249",
  "ai-rendering-library": "/ai-rendering-library/static-1.10590",
  "chirp-fetch": "/chirp-fetch/static-1.2001",
  "connections-embed-lib": "/connections-embed-lib/static-1.1210",
  "copilot-toolkit": "/copilot-toolkit/static-1.11435",
  "feedback-loader": "/feedback-loader/static-1.29516",
  "laboratory-lib": "/laboratory-lib/static-3.7267",
  "marketplace-embed": "/marketplace-embed/static-1.22454",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10051",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20111",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14326",
  "sanitize-text": "/sanitize-text/static-1.8259",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8817",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5877",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5149",
  "wootric-nps": "/wootric-nps/static-1.7066",
  "quartz-head": "/quartz-head/static-1.841",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4765",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4264",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "reporting-data": "/reporting-data/static-1.68042",
  "cssUtils": "/cssUtils/static-1.824",
  "flux-actions": "/flux-actions/static-1.346",
  "HubStyle": "/HubStyle/static-2.11896",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10321",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10476",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7453",
  "icons": "/icons/static-2.654",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18688",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4625",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5646",
  "quartz-i18n": "/quartz-i18n/static-1.851",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.16",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.378",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.579",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.712",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.36",
  "slack-ui-library": "/slack-ui-library/static-1.10510",
  "fsm": "/fsm/static-1.3842",
  "customer-data-objects": "/customer-data-objects/static-1.7792",
  "property-translator": "/property-translator/static-1.5510",
  "hs-locale-management": "/hs-locale-management/static-1.165",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8041",
  "hs-promise-utils": "/hs-promise-utils/static-1.5706",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4991",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13940",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5720",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7896",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4590",
  "superstore": "/superstore/static-1.4873",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10361",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8072",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "hubspotter-http": "/hubspotter-http/static-1.4734",
  "immutable-less": "/immutable-less/static-1.4767",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17563",
  "nav-meta": "/nav-meta/static-1.29933",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18150",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3929",
  "property-management-common": "/property-management-common/static-1.5842",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9181",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.851",
  "quartz-test": "/quartz-test/static-1.851",
  "quartz-tracking": "/quartz-tracking/static-1.555",
  "trellis-components": "/trellis-components/static-1.2211",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.181",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21846",
  "ContentUtils": "/ContentUtils/static-1.68698",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13143",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2611",
  "breeze-engine-core": "/breeze-engine-core/static-1.398",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.251",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40200",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13288",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14751",
  "ExportDialog": "/ExportDialog/static-6.10494",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41598",
  "reporting-snowflake": "/reporting-snowflake/static-1.56660",
  "reporting-ui-components": "/reporting-ui-components/static-2.65313",
  "reporting-visualizations": "/reporting-visualizations/static-1.60118",
  "trellis-theming": "/trellis-theming/static-1.1055",
  "ui-addon-teams": "/ui-addon-teams/static-1.21698",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.183",
  "magpie-lib": "/magpie-lib/static-1.5626",
  "navigation-components": "/navigation-components/static-1.18296",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1120",
  "magpie-types": "/magpie-types/static-1.5086",
  "simple-logging-lib": "/simple-logging-lib/static-1.3162",
  "ai-studio-lib": "/ai-studio-lib/static-1.11953",
  "app-governance-lib": "/app-governance-lib/static-1.1921",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10627",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8122",
  "ui-product-approvals": "/ui-product-approvals/static-1.28617",
  "ui-tool-access": "/ui-tool-access/static-1.10263",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9423",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5880",
  "usage-tracker-public": "/usage-tracker-public/static-1.7274",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3670",
  "persist-promise": "/persist-promise/static-1.3814",
  "reference-resolvers": "/reference-resolvers/static-1.8288",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4037",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.450",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3131",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3102",
  "atom": "/atom/static-1.5189",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6090",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1657",
  "crm-component-utils": "/crm-component-utils/static-1.39385",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6003",
  "customer-data-properties": "/customer-data-properties/static-1.51970",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7006",
  "property-value-citations": "/property-value-citations/static-1.2584",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8211",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9181",
  "navigation-messaging": "/navigation-messaging/static-1.7623",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10248",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4929",
  "content-icons-ui": "/content-icons-ui/static-1.2258",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9939",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7361",
  "crm-message-bus": "/crm-message-bus/static-1.43285",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22635",
  "events-data-lib": "/events-data-lib/static-1.346",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4836",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4087",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6911",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1096",
  "onboarding-tours": "/onboarding-tours/static-1.16820",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14013",
  "academy-common-lib": "/academy-common-lib/static-1.14211",
  "content-assistance-lib": "/content-assistance-lib/static-1.7939",
  "dashboard-lib": "/dashboard-lib/static-1.81983",
  "file-manager-components": "/file-manager-components/static-1.23948",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18734",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18571",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18563",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20033",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8818",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4873",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11179",
  "user-context": "/user-context/static-1.5223",
  "growth-payments-core": "/growth-payments-core/static-1.25719",
  "reporting-plugins": "/reporting-plugins/static-1.10504",
  "reporting-reports": "/reporting-reports/static-1.67720",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.839",
  "nest": "/nest/static-1.345",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10741",
  "framework-listing-lib": "/framework-listing-lib/static-2.29019",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30976",
  "apps-service-types": "/apps-service-types/static-1.3913",
  "oauth-service-types": "/oauth-service-types/static-1.4367",
  "react-dnd-compat": "/react-dnd-compat/static-1.4728",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.512",
  "onboarding-scopes": "/onboarding-scopes/static-1.6574",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5034",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7756",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15064",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9601",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6093",
  "signup-constants": "/signup-constants/static-1.19126",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8171",
  "card-properties-lib": "/card-properties-lib/static-1.44540",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37411",
  "crm-actions": "/crm-actions/static-1.6454",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43934",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9577",
  "customer-data-tracking": "/customer-data-tracking/static-1.7001",
  "hs-resources": "/hs-resources/static-1.288",
  "pulse": "/pulse/static-1.717",
  "calling-global-api": "/calling-global-api/static-1.64913",
  "calling-internal-common": "/calling-internal-common/static-1.31424",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66295",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58589",
  "commerce-products-lib": "/commerce-products-lib/static-1.9988",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3880",
  "crm-links": "/crm-links/static-1.6422",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4220",
  "external-options-client-types": "/external-options-client-types/static-1.4210",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4300",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.747",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3773",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49145",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4049",
  "smart-property-lib": "/smart-property-lib/static-1.7813",
  "tiered-pricing": "/tiered-pricing/static-1.1518",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11104",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.125",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1172",
  "growth-data-modal": "/growth-data-modal/static-1.5615",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3179",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2250",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.886",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7742",
  "academy-service-client": "/academy-service-client/static-1.3797",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39447",
  "FileManagerLib": "/FileManagerLib/static-1.39588",
  "SafeStorage": "/SafeStorage/static-1.4513",
  "video-embed": "/video-embed/static-1.36144",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28882",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11652",
  "video-data-lib": "/video-data-lib/static-1.35310",
  "content-media-capture": "/content-media-capture/static-1.4863",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23829",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10000",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24630",
  "viral-links-lib": "/viral-links-lib/static-1.7181",
  "data-token-picker": "/data-token-picker/static-1.16613",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.338",
  "timezone-utils": "/timezone-utils/static-2.5357",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17852",
  "ui-addon-opt": "/ui-addon-opt/static-4.8475",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9442",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25680",
  "framework-data-table": "/framework-data-table/static-2.12182",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6979",
  "nudge-client-utils": "/nudge-client-utils/static-1.2824",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1231",
  "switchboard-lib": "/switchboard-lib/static-1.337",
  "app-users-service-client": "/app-users-service-client/static-1.5722",
  "app-users-service-types": "/app-users-service-types/static-1.5130",
  "mini-checkout-client": "/mini-checkout-client/static-1.27094",
  "onboarding-utils": "/onboarding-utils/static-1.5472",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28867",
  "edison-service-client-types": "/edison-service-client-types/static-1.503",
  "crm_data": "/crm_data/static-4.92332",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46334",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16931",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4374",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1252",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19469",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18820",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10685",
  "crm-fe-perf": "/crm-fe-perf/static-1.23016",
  "event-emitter": "/event-emitter/static-1.1063",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.220",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31431",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11149",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6657",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1440",
  "commerce-permissions": "/commerce-permissions/static-1.890",
  "products-iframe-lib": "/products-iframe-lib/static-1.8251",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10632",
  "data-agent-kit": "/data-agent-kit/static-1.388",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10333",
  "policy-lib": "/policy-lib/static-1.6896",
  "react-tinymce": "/react-tinymce/static-1.55551",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10396",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54677",
  "tinymce-plugins": "/tinymce-plugins/static-1.57791",
  "tinymce-themes": "/tinymce-themes/static-1.56647",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2162",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2278",
  "user-context-client": "/user-context-client/static-1.4694",
  "audio-components": "/audio-components/static-1.6095",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37099",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4649",
  "video-components": "/video-components/static-1.13654",
  "outpost": "/outpost/static-1.4283",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6692",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12667",
  "content-media-compositions": "/content-media-compositions/static-2.16674",
  "media-bridge-lib": "/media-bridge-lib/static-1.19128",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4539",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6313",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5195",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3707",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21881",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3964",
  "ts-utils-lib": "/ts-utils-lib/static-1.287",
  "crm-export-dialog": "/crm-export-dialog/static-1.6399",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6555",
  "crm-view-components": "/crm-view-components/static-1.625",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7445",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2581",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2900",
  "whisper-core-api": "/whisper-core-api/static-1.6872",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15115",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5805",
  "settings-content-modals": "/settings-content-modals/static-1.46409",
  "crm_universal": "/crm_universal/static-1.22215",
  "customer-data-email": "/customer-data-email/static-1.18242",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37506",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39834",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12622",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55105",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21783",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18271",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72404",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5457",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9845",
  "utility-belt": "/utility-belt/static-1.2645",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23254",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7715",
  "customer-data-rte": "/customer-data-rte/static-1.33301",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5955",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5220",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38494",
  "trials-service-types": "/trials-service-types/static-1.3996",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36217",
  "sales-views-client-types": "/sales-views-client-types/static-1.4370",
  "hub-http-contrib": "/hub-http-contrib/static-1.3157",
  "interframe": "/interframe/static-3.4874",
  "tinymce-data": "/tinymce-data/static-1.40762",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5324",
  "layout-dnd-components": "/layout-dnd-components/static-1.12672",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11647",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15699",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9137",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7719",
  "social-insights-client-types": "/social-insights-client-types/static-1.22339",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4286",
  "checkout-sdk": "/checkout-sdk/static-3.23937",
  "company-details-components": "/company-details-components/static-1.6311",
  "payment-method-components": "/payment-method-components/static-1.6985",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14705",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3579",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3635",
  "access-control-lib": "/access-control-lib/static-1.10550",
  "EmailComponents": "/EmailComponents/static-1.55091",
  "EmailData": "/EmailData/static-1.53768",
  "redux-less": "/redux-less/static-2.9596",
  "sequences-lib": "/sequences-lib/static-1.8244",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10463",
  "products-ui-components": "/products-ui-components/static-1.40506",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7255",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55121",
  "commerce-products-api": "/commerce-products-api/static-1.2464",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57179",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103082",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81125",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28567",
  "ContentData": "/ContentData/static-1.68773",
  "layout-data-lib": "/layout-data-lib/static-1.9972",
  "checkout-service-types": "/checkout-service-types/static-1.3880",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.810",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4051",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4104",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.670",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18718",
  "pricing-pages-api": "/pricing-pages-api/static-1.14570",
  "ContentComponents": "/ContentComponents/static-2.71654",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10429",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46602",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1464",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19220",
  "automation-ui-types": "/automation-ui-types/static-1.20138",
  "messaging-types-lib": "/messaging-types-lib/static-1.46339",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4618",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8101",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.649",
  "price-books-api": "/price-books-api/static-1.1242",
  "price-books-components": "/price-books-components/static-1.1300",
  "property-description-translator": "/property-description-translator/static-1.3954",
  "ramp-editor": "/ramp-editor/static-1.452",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3695",
  "totals-ui-components": "/totals-ui-components/static-1.23912",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9405",
  "advanced-menus-core": "/advanced-menus-core/static-1.15321",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12234",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34353",
  "segments-query-core": "/segments-query-core/static-1.1534",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6054",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7452",
  "data-token-views": "/data-token-views/static-1.16594",
  "forms-utils-lib": "/forms-utils-lib/static-1.12801",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13270",
  "simple-menus-core": "/simple-menus-core/static-1.15320",
  "simple-menus-lib": "/simple-menus-lib/static-1.16837",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6994",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.12",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7625",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77432",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4037",
  "web-interactives-components": "/web-interactives-components/static-1.13965",
  "web-interactives-data": "/web-interactives-data/static-1.13966",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.913",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1083",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1090",
  "line-items-api": "/line-items-api/static-1.860",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3901",
  "FireAlarmUi": "/FireAlarmUi/static-1.4590",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4252",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22074",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21537",
  "data-studio-ubb": "/data-studio-ubb/static-1.3057",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27283",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58186",
  "content-management-data-lib": "/content-management-data-lib/static-1.5608",
  "copilot-plugins": "/copilot-plugins/static-1.11408",
  "cta-picker": "/cta-picker/static-1.36704",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3414",
  "editor-components": "/editor-components/static-1.13399",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8565",
  "error-messaging-js": "/error-messaging-js/static-1.5307",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86128",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10760",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1858",
  "smart-content-core": "/smart-content-core/static-1.42756",
  "smart-content-lib": "/smart-content-lib/static-1.43409",
  "social-composer-lib": "/social-composer-lib/static-1.59575",
  "structured-content-lib": "/structured-content-lib/static-1.25499",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53559",
  "tinymce-copilot": "/tinymce-copilot/static-1.16745",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8055",
  "automation-ui-routing": "/automation-ui-routing/static-1.21495",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5728",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42449",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3307",
  "reporting-enablement": "/reporting-enablement/static-1.23321",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21837",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2983",
  "forms-ai-lib": "/forms-ai-lib/static-1.4500",
  "codemirror-dlb": "/codemirror-dlb/static-1.58991",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6549",
  "report-customization-components": "/report-customization-components/static-1.13488",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13335",
  "reporting-filters": "/reporting-filters/static-1.610",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2085"
}
};
